/*
Contains constants related to application routes, 
such as route paths, route names, or route parameters.
*/
export const ROUTES = {
    HOME: '/',
    EMPTY: '',
    SERVER_ERROR: '/server_error',
    CUSTOMER: {
        ACCOUNT_REVIEWS: '/customer/account_reviews',
        ACCOUNT_REVIEW_PAGE: '/customer/account_review_page',
        DASHBOARD: '/customer/dashboard',
        DEFAULT: '/customer',
        DIGITAL_SAFETY_LIBRARY: '/customer/digital_safety_library',
        DIGITAL_LABOR_POSTERS: '/customer/digital_labor_law_poster',
        DOCUMENTS: '/customer/documents',
        EDIT_PROFILE: '/customer/edit_profile',
        FORGOT_PASSWORD: '/forgot_password',
        HIRING_CLIENTS: '/customer/hiring_clients',
        ACCOUNTS: '/customer/accounts',
        LEGEND: '/customer/legend',
        LOGIN: '/cloud/login',
        MY_FOLDERS_VIEW: '/customer/my_documents/folder_view',
        MY_DOCUMENTS_VIEW: '/customer/my_documents/document_view',
        NEWS_FEEDS: '/customer/news_feeds',
        NOTIFICATION: '/customer/notification',
        RESET_PASSWORD: '/reset_password',
        SAFETY_MEETINGS: '/customer/safety_meetings',
        SCORE_CARD_REPORT: '/customer/score_card_report',
        SCORE_CARD_LANDING_PAGE: '/customer/scorecard_landing_page',
        SIGNUP: '/cloud/signup',
        UPLOAD: '/upload',
    },
    ADMIN: {
        ACCOUNT_REVIEWS: '/admin/account_reviews',
        ACCOUNT_REVIEW_PAGE: '/admin/account_review_page',
        ADMIN: '/admin/admin_list',
        ADMIN_REGULATORY_ISSUE: '/admin/regulatory_issue',
        ADMIN_SCORE_CARD_LISTING: '/admin/score_card_listing',
        CONTENT_MANAGER: '/admin/content_manager_list',
        CSM: '/admin/csm_list',
        CUSTOMER: '/admin/customer',
        CUSTOMER_EDIT: '/admin/customer/edit',
        CUSTOMER_HIRING_CLIENT_ORDER: '/admin/hiring_client_order',
        DASHBOARD: '/admin/dashboard',
        DEFAULT: '/admin',
        DIGITAL_SAFETY_LIBRARY: '/admin/digital_safety_library',
        DIGITAL_LABOR_POSTERS: '/admin/digital_labor_law_poster',
        DOCUMENT_CATEGORY: '/admin/document_category',
        DOCUMENT_REQUEST: '/admin/document_request',
        DOCUMENTS: '/admin/documents',
        EDIT_PROFILE: '/admin/edit_profile',
        LEGEND: '/admin/legend',
        LOGIN: '/login',
        NEWS_FEED_ADMIN: '/admin/news_feed',
        NOTIFICATION: '/admin/notification',
        SAFETY_MEETINGS: '/admin/safety_meetings',
        SALES_AGENT: '/admin/sales_agent_list',
        SCORE_CARD_REPORT_ADMIN: '/admin/score_card_report',
        USER_VIEW: '/admin/user/view',
    },
};
